export default {
  details: '/gateway/capp/ActivityForAppRpcService/getPartnerActivityLevelRule'
}
